// import hooks
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";

// import components
import CardList1 from "../Main/CardList1";
import PastProductsList from "../Main/PastProductsList";
import { Form, Container, Row, Col } from "react-bootstrap";
import RoutPath from "../RoutPath";

// import assets
import "../../assets/css/product.css";
import {
    redHeart,
    goldOcean,
    star,
    goldStar,
    country,
    iIcon,
    barcode
} from "../../utils/cards-svgs";

import makeCountryAccounts from "../../utils/makeCountryAccounts";

// import data
import product from "../../utils/data/productData";
import cardListData from "../../utils/data/cardListData";

const Product = () => {
    const [accountCountry, setAccountCountry] = useState("ريال سعودى");
    const [ship, setShip] = useState(false);
    const [cardBalance, setCardBalance] = useState();
    const [price, setPrice] = useState(0);
    const [quantity, setQuantity] = useState(1);

    const [t, i18n] = useTranslation("global");
    const windowWidth = useWindowSize();

    // const [cardList, setCardList] = useState(cardListData[0])
    cardListData[0].title = "منتجات متشابه";

    const decreaseCount = () => {
        if (quantity > 1) {
            setQuantity(quantity - 1);
        }
    };

    useEffect(() => {
        setCardBalance(product.balance[0]);
    }, []);
    return (
        <section className="product-page ocean-section">
            <div className="product-container">
                <Container>
                    <Row>
                        <RoutPath cardBalance={cardBalance} />
                    </Row>
                    <Row className="product-row">
                        <Col lg={4}>
                            <img
                                src={product.icon}
                                alt="icon"
                                className="product-icon hide-lg"
                            />
                            <img
                                src={product.img}
                                alt="product image"
                                className="product-img"
                            />
                        </Col>
                        <Col
                            lg={{ span: 1, order: "last" }}
                            className="products-points-container"
                        >
                            <div className="products-icon-div">
                                <div className="svg-circle">
                                    <div className="share-svg ocean-svg "></div>
                                </div>
                                <div className="svg-circle">
                                    {product.wishList ? (
                                        <img
                                            src={redHeart}
                                            alt="heart icon"
                                            className="svg-image"
                                        />
                                    ) : (
                                        <div className="heart-svg ocean-svg"></div>
                                    )}
                                </div>
                            </div>
                            <div className="points-div">
                                <p className="ocean-p-grey">
                                    {t("product.youWillGet")}
                                </p>
                                <p className="gold-p">
                                    <img src={goldOcean} alt="ocean +" />
                                    <span>90 {t("product.points")}</span>
                                </p>
                            </div>
                        </Col>
                        <Col lg={7}>
                            <img
                                src={product.icon}
                                alt="icon"
                                className="product-icon hide-sm"
                            />
                            <h1 className="product-h">
                                {i18n.language == "ar"
                                    ? product.ar.head
                                    : product.en.head}
                            </h1>
                            <p className="ocean-p-grey">
                                {i18n.language == "ar"
                                    ? product.ar.headTxt
                                    : product.en.headTxt}
                                <span>{product.unitPrice}</span>
                            </p>
                            <div className="product-stars-div">
                                <div className="stars-div">
                                    {[...Array(product.stars)].map(
                                        (_val, i) => (
                                            <img
                                                src={goldStar}
                                                alt="star"
                                                className="card-star"
                                                key={i}
                                            />
                                        )
                                    )}
                                    {[...Array(5 - product.stars)].map(
                                        (_val, i) => (
                                            <img
                                                src={star}
                                                alt="star"
                                                className="card-star"
                                                key={i}
                                            />
                                        )
                                    )}
                                </div>
                                <p className="rate-div">
                                    {`${product.rates} ${t("product.review")}`}
                                </p>
                            </div>
                            <div className="ocean-col">
                                <div className="product-desrcribtion">
                                    <p className="ocean-p-grey">
                                        {i18n.language == "ar"
                                            ? product.ar.desrcribtion
                                            : product.en.desrcribtion}
                                    </p>
                                </div>

                                <div className="country-account-div product-section-div">
                                    <h4 className="product-h4">
                                        <img src={country} alt="globe icon" />
                                        <span>
                                            {t("product.account-country")}
                                        </span>
                                    </h4>
                                    <div className="countries product-section">
                                        {windowWidth >= 992 ? (
                                            makeCountryAccounts(
                                                product.stores,
                                                i18n.language
                                            ).map((s) => (
                                                <div className="store-account">
                                                    <img
                                                        src={s.flag}
                                                        alt="flag"
                                                    />
                                                    <span>{s.name}</span>
                                                </div>
                                            ))
                                        ) : (
                                            // small screen
                                            <Form.Select aria-label="Default select example">
                                                <option>
                                                    {t(
                                                        "product.account-country"
                                                    )}
                                                </option>
                                                {makeCountryAccounts(
                                                    product.stores,
                                                    i18n.language
                                                ).map((s) => (
                                                    <option
                                                        value={s.country}
                                                        className="store-account-sm"
                                                        key={s.country}
                                                    >
                                                        {/* <img
                                                            src={s.flag}
                                                            alt="flag"
                                                        /> */}
                                                        <span>{s.name}</span>
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        )}
                                    </div>
                                </div>

                                <div className="ship-it-div product-section-div">
                                    <h4 className="product-h4">
                                        <Form.Check
                                            inline
                                            type="checkbox"
                                            id="inline-checkbox-1"
                                            onClick={() => setShip(!ship)}
                                        />
                                        <span>{t("product.ship")}</span>
                                    </h4>
                                    <div className="product-section">
                                        <input
                                            type="text"
                                            placeholder={t("product.id")}
                                            className="ocean-input"
                                            disabled={!ship}
                                        />
                                    </div>
                                </div>

                                <div className="card-balance-div product-section-div">
                                    <h4 className="product-h4">
                                        <span>{t("product.card-balance")}</span>
                                    </h4>
                                    <div className="countries product-section">
                                        {windowWidth >= 992 ? (
                                            product.balance.map((b) => (
                                                <div
                                                    className="store-account"
                                                    key={b}
                                                >
                                                    <span>
                                                        {b}
                                                        {t(
                                                            "product.currencies.dollar"
                                                        )}
                                                    </span>
                                                </div>
                                            ))
                                        ) : (
                                            // small screen
                                            <Form.Select aria-label="Default select example">
                                                <option>
                                                    {t("product.card-balance")}
                                                </option>
                                                {product.balance.map((b) => (
                                                    <option
                                                        value={b}
                                                        className="store-account-sm"
                                                        key={b}
                                                    >
                                                        <span>
                                                            {b}{" "}
                                                            {t(
                                                                "product.currencies.dollar"
                                                            )}
                                                        </span>
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        )}
                                    </div>
                                </div>

                                <div className="price-div">
                                    <Row>
                                        <Col
                                            sm={{ span: 9, order: 1 }}
                                            lg={{ span: 12, order: 1 }}
                                        >
                                            <h4 className="product-h4">
                                                <span>{`${t(
                                                    "product.price"
                                                )} ${price} ${accountCountry}`}</span>
                                            </h4>
                                        </Col>
                                        <Col
                                            sm={{ span: 3, order: 2 }}
                                            lg={{ span: 3, order: 3 }}
                                        >
                                            <div className="counter-div">
                                                <div
                                                    className="plus-btn"
                                                    onClick={() =>
                                                        setQuantity(
                                                            quantity + 1
                                                        )
                                                    }
                                                >
                                                    +
                                                </div>
                                                <div className="number">
                                                    {quantity}
                                                </div>
                                                <div
                                                    className="minus-btn"
                                                    onClick={decreaseCount}
                                                >
                                                    -
                                                </div>
                                            </div>
                                        </Col>

                                        <Col
                                            sm={{ span: 12, order: 3 }}
                                            lg={{ span: 9, order: 2 }}
                                        >
                                            <span className="carousel-btn">
                                                <div className="add-to-cart-svg"></div>
                                                <span>
                                                    {t("product.add-to-cart")}
                                                </span>
                                            </span>
                                        </Col>
                                    </Row>
                                </div>

                                <div className="model-n-div product-section-div">
                                    <h4 className="product-h4">
                                        <img src={barcode} alt="barcode" />
                                        <span>{t("product.model_n")}</span>
                                    </h4>
                                    <p>{product.modelNumber}</p>
                                </div>

                                <div className="how-to-use-div product-section-div">
                                    <h4 className="product-h4">
                                        <img src={iIcon} alt="!" />
                                        <span>{t("product.how-to-use")}</span>
                                    </h4>
                                    {i18n.language == "ar" ? (
                                        <div
                                            className="html-container"
                                            dangerouslySetInnerHTML={{
                                                __html: product.ar.howToUse
                                            }}
                                        ></div>
                                    ) : (
                                        <div
                                            className="html-container"
                                            dangerouslySetInnerHTML={{
                                                __html: product.en.howToUse
                                            }}
                                        ></div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <CardList1 list={cardListData[0]} />
            <PastProductsList />
        </section>
    );
};

export default Product;
